<template>
  <svg
    version="1.1"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="size"
    :heigth="size"
  >
    <!--Generated by IJSVG (https://github.com/iconjar/IJSVG)-->
    <path d="M0,0h24v24h-24Z" fill="none" />
    <path
      fill="currentColor"
      d="M17.001,2l1.793,1.793l-2.5,2.5l1.414,1.414l2.5,-2.5l1.793,1.793v-5Z"
    />
    <g fill="#757575">
      <path d="M7.001,2h-5v5l1.793,-1.793l2.5,2.5l1.414,-1.414l-2.5,-2.5Z" />
      <path
        d="M17.708,16.293l-1.414,1.414l2.5,2.5l-1.793,1.793h5v-5l-1.793,1.793Z"
      />
      <path
        d="M6.294,16.293l-2.5,2.5l-1.793,-1.793v5h5l-1.793,-1.793l2.5,-2.5Z"
      />
      <path
        d="M8.001,16c0,-2.301 1.449,-3.75 3.75,-3.75v0c2.301,0 3.75,1.449 3.75,3.75h-7.5Z"
      />
      <path
        d="M13.5188,6.73223c0.976311,0.976311 0.976311,2.55922 0,3.53553c-0.976311,0.976311 -2.55922,0.976311 -3.53553,0c-0.976311,-0.976311 -0.976311,-2.55922 0,-3.53553c0.976311,-0.976311 2.55922,-0.976311 3.53553,0"
      />
    </g>
  </svg>
</template>

<script>
'use strict'

import mixinIcon from '../mixinIcon'

export default {
  name: 'userExpand',
  mixins: [mixinIcon]
}
</script>

<style></style>
